import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { isIP } from 'is-ip';

// styles
import {
  RightNavContainer,
  RightNavContainerFoot,
  RightNavContainerX,
  RightNavContainerXPar,
  RightNavSecDiv,
  RNCFBtn,
  RNCFBtn2,
  SBMSDiv3,
  SBMSInput2,
  SDMHeading,
  SDMHeadingP,
  SideBarMainDiv,
  TeamHeadBtnImgP,
  TeamHeadBtnImgPa,
} from '../../styles';
import { ErrorWarning } from './styles';

// PNG
import cross from 'Assets/images/cross.png';

// Redux actions
import { apiGetInventoryOnPremServerInfoRequest, apiClearInventoryOnPremServerInfoRequest, apiOnboardOrgOnPremServerRequest, } from 'Redux/actions/gear';

const OnboardOnPremServer = ({
  onChangeRightNav,
  organisationId,
}) => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const gears = useSelector(state => state.gear);

  // useState
  const [onboardData, setOnboardData] = useState({
    air_id: '',
    nickname: '',
    default_lan_ip: '',
    default_wan_ip: '',
    organization: organisationId,
  });
  const [error, setError] = useState({
    air_id: '',
    nickname: '',
    default_lan_ip: '',
    default_wan_ip: '',
  });

  const formatAirId = (inputString) => {
    let digits = inputString.replace(/-/g, "");
    let digitChuckNum = Math.ceil(digits.length / 4);

    let result = '';
    for (let i = 0 ; i < digitChuckNum ; i++) {
      if (i !== digitChuckNum - 1) {
        result += digits.substring(i*4, i*4+4) + '-';
      } else {
        result += digits.substring(i*4);
      }
    }
    return result;
  }

  const handleAirIdChange = e => {
    const airId = formatAirId(e.target.value);

    setOnboardData(prev => ({
      ...prev,
      air_id: airId,
    }));
    setError(prev => ({
      ...prev,
      air_id: '',
    }));

    if (airId.length == 14) {
      dispatch(apiGetInventoryOnPremServerInfoRequest(auth.token, airId));
    }
  };

  const validateOnboardData = () => {
    const newErrors = {};
    let inventoryOnPremServerAirId = gears?.inventoryOnPremServerInfo?.air_id || '';
    const nickNameRegex = /^[a-zA-Z0-9\s]+$/;

    if (!onboardData?.air_id) {
      newErrors.air_id = 'This field is required';
    } else if (onboardData?.air_id.length !== 14) {
      newErrors.air_id = 'Invalid AIR ID';
    } else if (inventoryOnPremServerAirId !== onboardData?.air_id) {
      newErrors.air_id = 'Invalid AIR ID';
      toast.error("The AIR ID you provide does not match any Inventory AutoPilot Server, please contact A.I.R. to confirm the AIR ID");
    }

    if (!onboardData?.nickname) {
      newErrors.nickname = 'This field is required';
    } else if (nickNameRegex.test(onboardData?.nickname) === false) {
      newErrors.nickname = 'Nickname must only contains letters, numbers, and spaces.';
    }

    if (onboardData?.default_lan_ip.length > 0 && !isIP(onboardData?.default_lan_ip)){
      newErrors.default_lan_ip = 'Invalid LAN IP';
    }
    if (onboardData?.default_wan_ip.length > 0 && !isIP(onboardData?.default_wan_ip)){
      newErrors.default_wan_ip = 'Invalid WAN IP';
    }

    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const closeSideBar = () => {
    setOnboardData({});
    setError({});
    dispatch(apiClearInventoryOnPremServerInfoRequest());
    onChangeRightNav('');
  };

  const onConfirm = () => {
    const isValid = validateOnboardData();
    if (isValid) {
      dispatch(apiOnboardOrgOnPremServerRequest(auth.token, onboardData));
      closeSideBar();
    }
  };

  useEffect(() => {
    dispatch(apiClearInventoryOnPremServerInfoRequest());
  }, []);

  useEffect(() => {
    if (gears?.inventoryOnPremServerInfo?.air_nickname && onboardData?.nickname.length === 0) {
      setOnboardData(prev => ({
        ...prev,
        nickname: gears?.inventoryOnPremServerInfo?.air_nickname,
        air_on_prem_server: gears?.inventoryOnPremServerInfo?.id,
      }));
      setError(prev => ({
        ...prev,
        nickname: '',
      }));
    }
  }, [gears?.inventoryOnPremServerInfo]);

  return (
    <RightNavContainer>
      {/* =========================Header=================================== */}
      <RightNavContainerX onClick={closeSideBar}>
        <RightNavContainerXPar src={cross} />
      </RightNavContainerX>

      <SideBarMainDiv>
        <SDMHeading>Onboard AutoPilot Server</SDMHeading>
        {/* =========================Body=================================== */}
        <RightNavSecDiv
          style={{
            padding: '5px',
            marginBottom: '70px',
            paddingBottom: '50px',
          }}
        >
          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>AIR ID</SDMHeadingP>
            <SBMSDiv3>
              <SBMSInput2
                type="text"
                placeholder="0000-0000-0000"
                maxLength={14}
                value={onboardData?.air_id}
                onChange={handleAirIdChange}
              />
            </SBMSDiv3>
            {error?.air_id && (
              <ErrorWarning>
                {error.air_id}
              </ErrorWarning>
            )}
          </div>

          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>Nickname</SDMHeadingP>
            <SBMSDiv3>
              <SBMSInput2
                type="text"
                placeholder="Enter Nickname"
                maxLength={30}
                onChange={e => {
                  setOnboardData(prev => ({ ...prev, nickname: e.target.value }))
                  setError(prev => ({ ...prev, nickname: '' }));
                }}
                value={onboardData?.nickname}
              />
            </SBMSDiv3>
            {error?.nickname && (
              <ErrorWarning>
                {error.nickname}
              </ErrorWarning>
            )}
          </div>

          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>Default LAN IP</SDMHeadingP>
            <input
              type="text"
              className="form-control"
              placeholder="Example: 123.123.123.123"
              maxLength={30}
              value={onboardData?.default_lan_ip}
              onChange={e => {
                setOnboardData(prev => ({ ...prev, default_lan_ip: e.target.value }));
                setError(prev => ({ ...prev, default_lan_ip: '' }));
              }}
            />
            {error?.default_lan_ip && (
              <ErrorWarning>
                {error.default_lan_ip}
              </ErrorWarning>
            )}
          </div>

          <div style={{ marginTop: 5 }}>
            <SDMHeadingP>Default WAN IP</SDMHeadingP>
            <input
              type="text"
              className="form-control"
              placeholder="Example: 123.123.123.123"
              maxLength={30}
              value={onboardData?.default_wan_ip}
              onChange={e => {
                setOnboardData(prev => ({ ...prev, default_wan_ip: e.target.value }));
                setError(prev => ({ ...prev, default_wan_ip: '' }));
              }}
            />
            {error?.default_wan_ip && (
              <ErrorWarning>
                {error.default_wan_ip}
              </ErrorWarning>
            )}
          </div>
        </RightNavSecDiv>
      </SideBarMainDiv>

      {/* =========================Footer=================================== */}
      <RightNavContainerFoot>
        <RNCFBtn>
          <TeamHeadBtnImgP onClick={closeSideBar}>Cancel</TeamHeadBtnImgP>
        </RNCFBtn>
        <RNCFBtn2>
          <TeamHeadBtnImgPa onClick={onConfirm}>Confirm</TeamHeadBtnImgPa>
        </RNCFBtn2>
      </RightNavContainerFoot>
    </RightNavContainer>
  );
};

export default OnboardOnPremServer;
